export default "__VITE_ASSET__NMFztN1___"